// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__v45Q7","withMargin":"panel_withMargin__IbDbi","withPadding":"panel_withPadding__qUaac","open":"panel_open__W3pQZ","fullHeight":"panel_fullHeight__zGON4"};